module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qnerv12-4e735ab1b57d5bdef3c05fe4788f1387.jpg";